import React from 'react';
import { Link } from 'react-router-dom';

function PlatformSettingsPage() {
  return (
    <div>
      <h1 className="product-page-title">Platform Settings</h1>
      <p className="product-page-subtitle">Global Bakeonator configuration.</p>
      <div className="product-card">
        <p className="mb-2 text-muted">
          Platform-wide settings management will be expanded in a future slice. Contact a platform
          owner for configuration changes today.
        </p>
        <p className="mb-0">
          Manage platform role assignments on the{' '}
          <Link to="/platform/team">Platform team</Link> page.
        </p>
      </div>
    </div>
  );
}

export default PlatformSettingsPage;
